import Component from '@bythepixel/component-loader';
import Animations from '@Front/animations';

const DEFAULTS = {
  contentSelector: '[data-comp-footer-content',
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.2,
  },
};

export default class FooterController extends Component {
  static selector = '[data-comp-footer-controller]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    this.footerContent = document.querySelector(options.contentSelector);
    this.mount();
  }

  attachObserver() {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          Animations.maskReveal(entry.target, {
            yStart: 150,
            yEnd: 0,
            ease: 'power1',
            duration: 1,
          });
          obs.disconnect();
        }
      });
    }, this.$options.observerOptions);

    observer.observe(this.footerContent);
  }

  mount() {
    this.attachObserver();
  }
}
